import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * NavbarEnd - A className-based implementation that matches the Bulma NavbarEnd
 * 
 * This component provides the same API as Bloomer's NavbarEnd for easy migration
 */
const NavbarEnd = ({
  children,
  className,
  ...rest
}) => {
  const navbarEndClasses = classNames('navbar-end', {
    [className]: className,
  });

  return (
    <div className={navbarEndClasses} {...rest}>
      {children}
    </div>
  );
};

NavbarEnd.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

NavbarEnd.defaultProps = {
  children: null,
  className: '',
};

export default NavbarEnd;
